import data from './data'
import methods from './methods'
import validations from './validations'

export default {
  data,
  methods,
  validations
}



// WEBPACK FOOTER //
// ./src/app/settings/profile/components/disabled-account/resources/index.js